module.exports = __webpack_public_path__ + "img/LaBase-Club-600px.59720c01.jpg";